import * as angular from 'angular';

import NewSchedulesController from './new-schedules-controller';
import template from './schedules.html';

const NewSchedulesComponent: angular.IComponentOptions = {
  bindings: {
    report: '<',
    run: '<',
    dismiss: '&',
    startSchedule: '<',
    owner: '<',
    account: '<',
    slackAppTeamName: '<',
    slackAppUrl: '<',
    view: '@',
    onUpdate: '&?',
  },
  controller: NewSchedulesController,
  controllerAs: 'ctrl',
  template,
};

angular.module('mode.components').component('modeNewSchedules', NewSchedulesComponent);
